import _ from 'lodash';
import { CampaignDefaultFields } from '../interfaces/campaign';
import { SmsHtmlParser } from './smsHtmlParser';

export const getCampaignDefaultFields = (
  columns: any[]
): CampaignDefaultFields => {
  const orderedColumns = _.sortBy(columns, column => column.order).filter(
    c => c.id !== 'communication_preference'
  );

  return Object.assign(
    {},
    ...orderedColumns.map(({ id, name, required }) => {
      let value = '';
      if (id === 'first_name') value = 'there';
      return {
        [id]: {
          name,
          value,
          required
        }
      };
    })
  );
};

// Used in SMS preview on SMS page. When the user hasn't provided a default value for a field,
// we want to show {{Field name}} in the SMS preview, rather than nothing (empty string).
export const replaceEmptyFieldValuesWithPlaceholderValues = (
  fieldValues: Record<string, string>,
  fieldData: CampaignDefaultFields
): Record<string, string> => {
  return Object.fromEntries(
    Object.entries(fieldValues).map(([fieldId, fieldValue]) => {
      const newFieldValue = fieldValue
        ? fieldValue
        : `{{${fieldData[fieldId].name}}}`;
      return [fieldId, newFieldValue];
    })
  );
};

export const escapePersonalizedFieldValues = (
  fieldValues: Record<string, string>
): Record<string, string> => {
  return Object.fromEntries(
    Object.entries(fieldValues).map(([fieldId, fieldValue]) => {
      return [fieldId, SmsHtmlParser.escapeHtml(fieldValue)];
    })
  );
};

export const getFieldNameToIdMapping = (
  fieldData: CampaignDefaultFields
): Record<string, string> => {
  const idToNameMapping = _.mapValues(fieldData, 'name');
  return _.invert(idToNameMapping);
};

// Used in SMS preview on Review page. When the user has provided a contact to preview as,
// replaces default field value with contact's detail.
export const replaceFieldValuesWithContactValues = (
  contact: any,
  fieldValues: Record<string, string>
): Record<string, any> => {
  const transformedContact = Object.fromEntries(
    Object.entries(contact).map(([id, value]) => {
      return [id, value];
    })
  );

  return Object.fromEntries(
    Object.entries(fieldValues).map(([fieldId, fieldValue]) => {
      const newFieldValue = !fieldIsEmpty(transformedContact[fieldId])
        ? transformedContact[fieldId]
        : fieldValue;
      return [fieldId, newFieldValue];
    })
  );
};

function fieldIsEmpty(fieldValue): boolean {
  return (
    fieldValue == null || (typeof fieldValue === 'string' && !fieldValue.length)
  );
}
